import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { T } from '@fullcalendar/core/internal-common';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Observable, startWith, map } from 'rxjs';

@Component({
  selector: 'app-autocomplete-generico',
  standalone: true,
  templateUrl: './autocomplete-generico.component.html',
  styleUrl: './autocomplete-generico.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteGenericoComponent),
      multi: true,
    }
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    NgxSpinnerModule,
    AsyncPipe
  ]
})
export class AutocompleteGenericoComponent<T> implements OnInit, ControlValueAccessor {


  @Input() label: string = 'Seleccione';
  @Input() nombreSpinner: string = '';
  @Input() showSpinner: boolean = false;
  @Input() habilitado: boolean = false;
  @Output() seleccionar = new EventEmitter<T>();
  @Input() datos: T[] = [];
  @Input() mostrarPropiedad!: keyof T;
  @Input() idPropiedad!: keyof T;

  opcionesFiltradas!: Observable<T[]>;
  inputValue: string = '';
  selectedValue!: T;

  control = new FormControl();

  private onChange = (_: any) => { };
  private onTouched = () => { };
  constructor(
    private spinner: NgxSpinnerService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.opcionesFiltradas = this.control.valueChanges.pipe(
      startWith(''),
      map(value => this.filtrar(value || ''))
    );

    this.control.valueChanges.subscribe(value => {
      this.onChange(value?.[this.idPropiedad] || null);
       this.seleccionar.emit(value); // 👉 Esto faltaba
    });

    if (this.showSpinner)
      this.spinner.show(this.nombreSpinner)
    else
      this.spinner.hide(this.nombreSpinner)
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Volver a conectar el pipe si cambian los datos
    if (changes['datos'] && !changes['datos'].firstChange) {
      this.opcionesFiltradas = this.control.valueChanges.pipe(
        startWith(''),
        map(value => this.filtrar(value || ''))
      );
    }
   if (changes['showSpinner']) {
    if (this.showSpinner) {
      this.spinner.show(this.nombreSpinner);
    } else {
      this.spinner.hide(this.nombreSpinner);
    }
  }
  }

  filtrar(value: string): any[] {
    const filterValue = value?.toLowerCase?.() || '';
    return this.datos.filter(option => {
      const prop = option[this.mostrarPropiedad] as string;
      return prop?.toLowerCase().includes(filterValue);
    });
  }

  writeValue(value: any): void {
    if (value) {
      // Encontrar el objeto seleccionado
      const selected = this.datos.find(d => d[this.idPropiedad] === value);
      if (selected) {
        this.control.setValue(selected);
      }
    } else {
      this.control.setValue(null);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  displayFn(item: any): string {
    return item ? item[this.mostrarPropiedad] : '';
  }
}
